// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { roundAndLeaveTrailingZeroes } from 'helpers/reduxFormFunctions'
import { readonlyPrecisionFt } from 'config/constants'

const customReadonlyValueFeet = v => roundAndLeaveTrailingZeroes(v, readonlyPrecisionFt)

export default customReadonlyValueFeet
